<arc-translation-input
    [labelKey]="columnModel.columnTitleKey"
    [controlDe]="controlDe"
    [controlEn]="controlEn"
    [controlFr]="controlFr"
    [controlIt]="controlIt" />
<ng-template #readonlyTpl>
    <p>Not Implemented</p>
</ng-template>
